export const DEFAULT_MESSAGE = "US & Canada: Free shipping over $100";
export const CURRENCIES = ["CAD", "USD", "AUD", "EUR", "GBP"];
